<template>
	<div class="investmentServices">
		<div class="parkService__title">
			<p>投资服务</p>
			<div class="parkService__border"></div>
		</div>
		<div class="parkService__center">
			<p class="parkService__center--num">1.</p>
			<p class="parkService__center--title">股权投资基金</p>
		</div>
		<div class="parkService__service">
			<div class="parkService__content">
				<p>
					{{
						company
					}}联合广州广电研究院有限公司、广州广电平云资本管理有限公司成立平云创科（广州）股权投资基金合伙企业的基金，首期规模为5000万元，投资主方向为芯片、智能感知、信创产业等。广州无线电集团发起成立的海纳科创（广州）股权投资基金合伙企业（有限合伙），规模达5个亿，也已落户中国科协广州科技园。两个股权投资基金将夯实园区的投资孵化功能，帮助优质企业及时获得融资，加速孵化器内企业成长。
				</p>
				<br />
			</div>
			<p
				class="parkService__font"
				style="text-align: left; margin-bottom: 30px"
			>
				如有优质企业需获得投融资，请将商业计划书发送到邮箱280915805@qq.com。
			</p>
			<!--			<div class="parkService__btn" style="margin-bottom: 0">
				下载商业计划书
				<i class="el-icon-download"></i>
			</div>-->
		</div>
		<div class="parkService__center">
			<p class="parkService__center--num">2.</p>
			<p class="parkService__center--title">广州市科技金融工作站</p>
		</div>
		<div class="parkService__service">
			<div class="parkService__content">
				<p>
					{{
						company
					}}作为广州市科技金融工作站，将依托自身和股东的资源，以及中小企业优势，开展一系列的银企对接和科技金融等服务。
				</p>
				<br />
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
export default {
	props: {},
	data() {
		return {}
	},
	computed: {
		...mapState(['company']),
	},
	created() {},
	mounted() {},
	watch: {},
	methods: {},
	components: {},
}
</script>

<style lang="scss">
.investmentServices {
	text-align: center;
	padding-bottom: 40px;
}
</style>
